/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItem_item = {
    readonly serviceId: string | null;
    readonly isFurniture: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"ItemTile_item">;
    readonly " $refType": "PdpRespSimilarItem_item";
};
export type PdpRespSimilarItem_item$data = PdpRespSimilarItem_item;
export type PdpRespSimilarItem_item$key = {
    readonly " $data"?: PdpRespSimilarItem_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFurniture",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemTile_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '43420e536c07ec1a625973f58c3d4206';
export default node;
